<template>
  <ValidationProvider
    v-slot="{ errors }"
    class="w-full my-1"
    :name="label"
    :rules="rules"
  >
    <label
      v-if="type !== 'checkbox'"
      :for="inputId"
      :class="` xn-label cursor-pointer ${disabled ? 'text-light' : ''}`"
    >
      {{ label }} {{ showRequired }}
      <p
        v-if="subLabel"
        class="text-sm text-dark pb-2"
      >
        {{ subLabel }}
      </p>
    </label>
    <a
      v-if="type !== 'checkbox' && infoUrl"
      :href="infoUrl"
      rel="noopener noreferrer"
      target="_blank"
      class="far fa-question-circle mx-1 text-info cursor-pointer"
    />

    <select
      v-if="type === 'select'"
      :id="inputId"
      :required="required"
      class="xn-input text-dark"
      :class="{ 'text-muted': !value, 'xn-input-border': border }"
      :value="value"
      :disabled="disabledVal"
      v-on="listeners"
      v-tooltip="vTooltipProp"
    >
      <option
        v-if="placeholder"
        value=""
        disabled
        selected
        hidden
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.id ? option.id : option"
        class="text-dark"
        :value="option.id ? option.id : option"
      >
        {{ option.name ? option.name : option | capitalize }}
      </option>
    </select>

    <textarea
      v-else-if="type === 'textarea'"
      :id="inputId"
      class="xn-input text-dark"
      :class="{ 'xn-input-border': border }"
      :required="required"
      :value="value"
      :disabled="disabledVal"
      :placeholder="placeholderVal"
      :rows="lines ? lines : '3'"
      v-on="listeners"
      v-tooltip="vTooltipProp"
    />
    <input
      v-else-if="type === 'checkbox'"
      :id="inputId"
      v-model="checked"
      :class="{ 'xn-input-border': border }"
      :required="required"
      :type="type"
      :disabled="disabledVal"
      v-tooltip="vTooltipProp"
    >
    <input
      v-else-if="type === 'currency'"
      :id="inputId"
      v-model="proxyVal"
      class="xn-input text-dark"
      :class="{ 'xn-input-border': border }"
      :required="required"
      :type="type"
      :disabled="disabledVal"
      :placeholder="placeholderVal?placeholderVal:'$0.00'"
      v-on="listeners"
      v-tooltip="vTooltipProp"
    >
    <input
      v-else
      :id="inputId"
      class="xn-input text-dark"
      :class="{ 'xn-input-border': border }"
      :required="required"
      :value="value"
      :type="type"
      :min="min"
      :disabled="disabledVal"
      :placeholder="placeholderVal"
      v-on="listeners"
      v-tooltip="vTooltipProp"
    >
    <label
      v-if="type === 'checkbox'"
      :for="inputId"
      :class="` xn-label cursor-pointer ${disabled ? 'text-light' : ''}`"
    >
      {{ showRequired }} {{ label }}
      <!-- <p
        v-if="subLabel"
        class="text-sm text-dark pb-2"
      >
        {{ subLabel }}
      </p> -->
    </label>
    <a
      v-if="type === 'checkbox' && infoUrl"
      :href="infoUrl"
      rel="noopener noreferrer"
      target="_blank"
      class="far fa-question-circle mx-1 text-info cursor-pointer"
    />
    <span class="text-danger">{{ errors[0] }}</span>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, email, regex } from 'vee-validate/dist/rules'
import GeneralMixins from '../../mixins/GeneralMixins.vue'
extend('email', email)
extend('regex', regex)
extend('required', {
  ...required,
  message: 'This field is required',
})
export default {
  name: 'XnInput',
  components: {
    ValidationProvider,
  },
  mixins: [GeneralMixins],
  props: {
    id: { type: String, default: undefined },
    border: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    customValidation: {
      type: Object,
      default () {
        return {}
      },
    },
    label: { type: String, default: undefined },
    subLabel: {type: String, default: undefined},
    min:{type:String, default:undefined},
    infoUrl: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },
    noPlaceholder: { type: Boolean, default: false },
    options: {
      type: Array,
      default: () => {
        return []
      },
    },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    value: { type: [Boolean, String, Date, Number], default: null },
    lines: { type: Number, default: null },
    // this prop was added so that v-tooltip text can be passed into an
    // xn-input component and the tooltip will be over the input itself,
    // not the input/label/info text, etc.
    // implement like this <xn-input :v-tooltip-prop="'your tooltip here'" />
    vTooltipProp: { type: String, default: '' }
  },
  data () {
    return {
      focused: false,
      proxyVal:this.toCurrency(this.value),
    }
  },
  computed: {
    inputId () {
      return this.id ? this.id : this.label ? this.label : this.type
    },
    rules () {
      //${(this.required&&(this.type==='email'||this.customValidation))?"|":""}
      return {
        required: this.required,
        email: this.type === 'email',
        ...this.customValidation,
      }
    },
    checked: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    placeholderVal () {
      if (this.noPlaceholder) {
        return null
      }
      return this.placeholder ? this.placeholder : this.label
    },
    showRequired () {
      if (this.required) {
        return '*'
      }
      return ''
    },
    disabledVal () {
      return this.disabled
    },
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateVal,
        focus: this.onFocus,
        blur: this.onBlur,
      }
    },
  },
  methods: {
    updateVal (evt) {
      let value = evt.target.value
      if(this.type === 'currency'){
        let strip = this.stripCurrency(value)
        value = strip
        this.proxyVal=this.toCurrency(strip)
      }
      this.$emit('input', value !== '' ? value : null)
    },
    onFocus (evt) {
      this.focused = true
      this.$emit('focus', evt)
    },
    onBlur (evt) {
      this.focused = false
      this.$emit('blur', evt)
    },
  },
  filters: {
    capitalize(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    } 
  }
}
</script>
<style lang="postcss" scoped>
.xn-input {
  @apply p-2 rounded block w-full overflow-auto max-w-full min-w-min cursor-pointer !important;
}
.xn-input-border {
  @apply border-primary border-2;
}
label {
  @apply mb-1;
}
.xn-label {
  width: 20rem;
  max-width: 90%;
}
</style>
